var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Remove",
    transform: "translate(-913 -267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Remove-2",
    "data-name": "Remove",
    transform: "translate(913 267)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 16,
    height: 16,
    rx: 8,
    fill: "#fe7070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Close",
    d: "M8.335,3.891H5V.553a.553.553,0,0,0-1.107,0V3.891H.553A.553.553,0,0,0,.553,5H3.891V8.335A.553.553,0,1,0,5,8.335V5H8.335a.553.553,0,1,0,0-1.107Z",
    transform: "translate(8.064 1.777) rotate(45)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/removeIcon.ceb2d58bc7f95398bcefc60cefc690d5.svg";
export { ForwardRef as ReactComponent };